module.exports = __webpack_public_path__ + "static/img/logo_pfo.4f689fb0.png";